import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getDevData } from "../../services/generalService";
import { PaymentTransactionObj } from "../../utils/types";

const initialState: PaymentTransactionObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getPaymentRevTransactionDetails = createAsyncThunk(
  "loans/getPaymentRevTransactionDetails",
  async (url: string, thunkAPI) => {
    try {
      const data = await getDevData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

const paymentRevTransactionSlice = createSlice({
  name: "payment-transaction-details",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentRevTransactionDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPaymentRevTransactionDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getPaymentRevTransactionDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default paymentRevTransactionSlice.reducer;
